var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3333 11.2342L20 1.12305L2.66663 11.2342V28.7659L5.3502 30.3312L10.8337 28.1125C12.3445 27.5013 13.3334 26.0344 13.3334 24.4046V10.6667H16.0001V24.4046C16.0001 27.1211 14.352 29.5656 11.8339 30.5845L8.26199 32.0299L20 38.8768L37.3333 28.7659V11.2342ZM18.6666 16C18.6666 13.0545 21.0544 10.6667 24 10.6667H27.1112C29.8112 10.6667 32 12.8555 32 15.5555V16H29.3333V15.5555C29.3333 14.3283 28.3384 13.3333 27.1112 13.3333H24C22.5272 13.3333 21.3333 14.5273 21.3333 16C21.3333 17.4727 22.5272 18.6667 24 18.6667H26.6666C29.6122 18.6667 32 21.0545 32 24C32 26.9456 29.6122 29.3333 26.6666 29.3333H24C21.0544 29.3333 18.6666 26.9456 18.6666 24H21.3333C21.3333 25.4727 22.5272 26.6667 24 26.6667H26.6666C28.1394 26.6667 29.3333 25.4727 29.3333 24C29.3333 22.5273 28.1394 21.3333 26.6666 21.3333H24C21.0544 21.3333 18.6666 18.9455 18.6666 16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.02a2592209e33b355267d2d5655c91ff.svg";
export { ForwardRef as ReactComponent };